import { DISCORD_URL } from "@/lib/config";

const Navbar = () => {
  return (
    <nav data-testid="navbar" className="border-b border-red-500/20 px-6 py-4 bg-[#0c0d12]/90 backdrop-blur-md sticky top-0 z-50">
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <a href="/" data-testid="nav-logo" className="flex items-center gap-2">
          <svg className="w-8 h-8 text-[#ff4655]" viewBox="0 0 32 32" fill="none">
            <path d="M4 6L28 6L18 26L4 6Z" fill="#ff4655" />
            <path d="M12 6L28 22" stroke="#0c0d12" strokeWidth="2" />
          </svg>
          <span className="font-display text-2xl tracking-wider text-white uppercase">
            Scythe Products
          </span>
        </a>
        <div className="flex items-center gap-6">
          <a href="/games" data-testid="nav-link-games" className="hidden md:inline text-xs font-bold uppercase tracking-wider text-zinc-400 hover:text-[#ff4655] transition-colors">
            Games
          </a>
          <a href="/#pricing" data-testid="nav-link-pricing" className="hidden md:inline text-xs font-bold uppercase tracking-wider text-zinc-400 hover:text-[#ff4655] transition-colors">
            Pricing
          </a>
          <a href="/#faq" data-testid="nav-link-faq" className="hidden md:inline text-xs font-bold uppercase tracking-wider text-zinc-400 hover:text-[#ff4655] transition-colors">
            FAQ
          </a>
          <a
            href={DISCORD_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-join-discord-btn"
            className="px-5 py-2 bg-[#ff4655] text-white text-xs font-bold uppercase tracking-wider rounded skew-x-[-8deg] hover:bg-white hover:text-black transition-colors"
          >
            <span className="inline-block skew-x-[8deg]">Join Discord</span>
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
